/**
 * Filtering ingredient-details by data-filter-value
 * When show_filter is enabled, buttons filter elements instead of redirecting
 */
class PageDescriptionFilter {
    constructor(sectionId, showFilter) {
        this.sectionId = sectionId;
        this.showFilter = showFilter;
        this.filterButtons = [];
        this.ingredientItems = [];

        this.init();
    }

    init() {
        if (!this.showFilter) {
            return; // If filter is disabled, don't initialize
        }

        // Find all filter buttons
        const section = document.querySelector(
            `#shopify-section-${this.sectionId}`
        );
        if (!section) return;

        this.filterButtons = section.querySelectorAll(
            ".page-nav-link[data-filter-value_0]"
        );
        this.ingredientItems = document.querySelectorAll(
            ".ingredient-details-item[data-filter-value]"
        );

        if (
            this.filterButtons.length === 0 ||
            this.ingredientItems.length === 0
        ) {
            return;
        }

        // Add event listeners to buttons
        this.filterButtons.forEach((button) => {
            button.addEventListener("click", (e) =>
                this.handleButtonClick(e, button)
            );
        });

        // Set initial state (show all elements or only active ones)
        this.updateFilter();
    }

    handleButtonClick(e, button) {
        if (!this.showFilter) {
            return; // If filter is disabled, allow default behavior
        }

        e.preventDefault();
        e.stopPropagation();

        // Check if button is already active
        const isActive = button.classList.contains("active");

        // Remove active class from all buttons
        this.filterButtons.forEach((btn) => {
            btn.classList.remove("active");
        });

        // If button was not active, add active class to it
        if (!isActive) {
            button.classList.add("active");
        }

        // Apply filtering
        this.updateFilter();
    }

    updateFilter() {
        // Collect all filter values from all active buttons
        const activeFilterValues = new Set();

        this.filterButtons.forEach((button) => {
            if (button.classList.contains("active")) {
                // Collect all data-filter-value_* from active button
                let index = 0;
                let filterValue;

                while (
                    (filterValue = button.getAttribute(
                        `data-filter-value_${index}`
                    )) !== null
                ) {
                    activeFilterValues.add(filterValue);
                    index++;
                }
            }
        });

        // If there are no active buttons, show all elements
        if (activeFilterValues.size === 0) {
            this.ingredientItems.forEach((item) => {
                item.style.display = "";
                item.classList.remove("hide");
                item.classList.add("show");
            });
        } else {
            // Filter elements - show only those that match active filters
            this.ingredientItems.forEach((item) => {
                const itemFilterValue = item.getAttribute("data-filter-value");

                // Check if value matches active filters
                if (activeFilterValues.has(itemFilterValue)) {
                    item.style.display = "";
                    item.classList.remove("hide");
                    item.classList.add("show");
                } else {
                    item.style.display = "none";
                    item.classList.remove("show");
                    item.classList.add("hide");
                }
            });
        }

        // After filtering, add is-odd and is-even classes to visible elements
        const visibleItems = document.querySelectorAll(
            ".ingredient-details-item.show"
        );

        visibleItems.forEach((el, index) => {
            el.classList.toggle("is-odd", index % 2 === 0);
            el.classList.toggle("is-even", index % 2 === 1);
        });
    }
}

// Initialize for each page-description section
document.addEventListener("DOMContentLoaded", () => {
    const pageDescriptionSections = document.querySelectorAll(
        ".page-description-section"
    );

    pageDescriptionSections.forEach((section) => {
        // Find parent element with id shopify-section-*
        const parentSection = section.closest('[id^="shopify-section-"]');
        if (!parentSection) return;

        const sectionId = parentSection.id.replace("shopify-section-", "");
        if (!sectionId) return;

        // Get show_filter setting from data attribute
        const showFilterAttr = section.getAttribute("data-show-filter");
        const showFilter = showFilterAttr === "true";

        new PageDescriptionFilter(sectionId, showFilter);
    });
});

// Support for Shopify Theme Editor
if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
        const section = event.target.querySelector(".page-description-section");
        if (section) {
            const sectionId = event.target.id?.replace("shopify-section-", "");
            if (sectionId) {
                const showFilterAttr = section.getAttribute("data-show-filter");
                const showFilter = showFilterAttr === "true";

                new PageDescriptionFilter(sectionId, showFilter);
            }
        }
    });
}

export default PageDescriptionFilter;
